const dateFormat = {
  getFormattedDate(date, format = 'DD/MM/YYYY') {
    if (!date) {
      return '';
    }

    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day);
  },
  getFormattedDateISO(date) {
    return this.getFormattedDate(date, 'YYYY-MM-DD');
  },
  getFormattedDateTime(date, format = 'DD-MM-YYYY HH:MI:SS') {
    if (!date) {
      return '';
    }

    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('MI', minutes)
      .replace('SS', seconds);

//      console.log(dateFormat.getFormattedDateTime(date));
//      console.log(dateFormat.getFormattedDateTime(date, 'YYYY/MM/DD HH:MI:SS'));
  }
};

export default dateFormat;